import { Observable } from 'rxjs';
import {StorageUtil} from '../../helpers/storage-util';
import streamSaverDefault from 'streamsaver';

// Known issue: Chrome 100+ console noise from StreamSaver MITM race
//
// When Export Every CT triggers a download, the browser console shows:
//   "Uncaught TypeError: [StreamSaver] You didn't send a messageChannel"
//   at onMessage (mitm.html:66)
//
// Root cause: StreamSaver communicates between the main page and a hidden
// MITM iframe (/assets/filesaver/mitm.html) via MessageChannel. In modern
// Chrome the MITM iframe's onMessage handler can register after pipeTo()
// starts, losing the handshake. StreamSaver falls back to a direct download
// when this happens, so the file exports successfully — the error is benign
// console noise.
//
// Impact: None. The download works. Users are not affected.
//
// Future fix options:
// 1. Migrate to the File System Access API (showSaveFilePicker) — the modern
//    replacement for StreamSaver, but requires a user gesture.
// 2. Use a plain anchor-tag download for smaller exports that fit in memory,
//    removing the StreamSaver dependency entirely for those cases.
// 3. Upgrade streamsaver to a version that handles the race more gracefully,
//    if one becomes available.

export class FileStreams {

  // Overridable seam so tests can supply a stub. Strict ESM under esbuild
  // forbids mutating the module's default import binding, so we route
  // streamsaver access through a writable static property instead.
  public static streamSaver: any = streamSaverDefault;

  public static downloadFile(url: string,sessionId:string, fileName:string): Observable<Response> {
    const localData = StorageUtil.getUserData();
    const currentToken = localData?localData.token:null;

    const headers = new Headers({
      'Authorization': 'Bearer ' + currentToken,
      'esp-plan-sessionId': sessionId
    });
    return new Observable((observer) => {
      fetch(url, {
        headers,
        method: 'GET',
      }).then((response) => {

        if (response.status !== 200) {
          observer.error(new Error(response.statusText));
        } else {
          FileStreams.streamSaver.mitm = '/assets/filesaver/mitm.html';
          const fileStream = FileStreams.streamSaver.createWriteStream(fileName);
          response.body.pipeTo(fileStream);
          observer.next(response);
          observer.complete();
        }
      }).catch((error) => {
        console.log("download error");
        console.log(JSON.stringify(error));
        observer.error(error);
      });
    });
  }

}
